import { trimAndRemoveRepeatSpaces } from '@xmatters/common/utils/string';

export function transformStepLabel(value) {
  return value && trimAndRemoveRepeatSpaces(value);
}
